<template>
    <div class="code-input">
        <label class="form-field__label">{{ content.yourCode }}</label>
        <div class="code-input__container" :class="{ 'code-input__container--error' : codeState === 'invalid' || codeState === 'used' }">
            <div v-for="(char, key) in code" v-bind:key="key" class="code-input__char">
                <input type="text" :class="{ 'code-input__char--set' : code[key].length > 0 }" maxlength="1" v-model="code[key]" v-on:keyup="focusNextInput($event, key)" :ref="'input' + key">
            </div>
        </div>
        <p class="text text--small" v-html="content.codeInputText"></p>
        <div class="code-input__error-modal" v-show="codeState === 'invalid' || codeState === 'used' || codeState === 'error'">
            <p class="form-field__label form-field__label--error" v-if="codeState === 'invalid'">{{ content.errors.invalid }}</p>
            <p class="form-field__label form-field__label--error" v-if="codeState === 'used'">{{ content.errors.used }}</p>
            <p class="form-field__label form-field__label--error" v-if="codeState === 'error'">{{ content.errors.general }}</p>
            <button class="button button--secondary button--try-again" @click="reset">{{ content.tryAgain }}</button>
        </div>
    </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
       computed: {
          ...mapGetters([
              'content',
              'codeState'
          ])
       },
       methods: {
           ...mapActions([
               'checkCode',
               'resetCode'
           ]),
           focusNextInput: function(event, key) {
                if(event.key !== 'Backspace' && this.code[key].length === 1 && this.code[key + 1] === '') {
                    this.$refs['input' + (key + 1)][0].focus()
                } else if(event.key === 'Backspace' && key > 0 && this.code[key] === '') {
                    this.$refs['input' + (key - 1)][0].focus()
                    this.code[key - 1] = ''
                }
           },
           reset: function() {
               this.code = ['', '', '', '', '', '']
               this.resetCode()
           }
       },
        data() {
            return {
                code: ['', '', '', '', '', '']
            }
        },
        watch: {
            code: function() {
                if(!this.code.includes('')) {
                    this.checkCode(this.code.join(''));
                }
            },
            codeState: function() {
                if(this.codeState === null) {
                    this.code = ['', '', '', '', '', '']
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/sass/variables';

    .code-input {
        .text--small {
            margin-top: 30px;
            font-size: 14px;
            max-width: 310px;
        }

        .button {
            &--start {
                margin-top: 30px;
            }

            &--try-again {
                margin-top: 17px;
            }
        }
        .form-field__label {
            &--error {
                color: #d0021b;
            }
        }

        &__container {
            display: flex;
            margin-top: 15px;

            &--error {
                .code-input__char {
                    &--set {
                        border: 1px solid #ad0021b;
                    }
                    input {
                        color: #d0021b;

                        &:focus {
                            outline: none !important;
                            border: 1px solid #d0021b;
                            box-shadow: none;
                        }
                    }
                }
            }
        }

        &__char {
            width: 41px;
            height: 60px;
            margin-right: 10px;
            background-color: #ffffff;
            box-shadow: 0 0 5px 0 rgba(0,0,0,.08);

            &--set {
                border: 1px solid $camel-60;
            }

            input {
                width: 100%;
                height: 100%;
                padding: 15px 0;
                text-align: center;
                color: $camel-60;
                text-transform: uppercase;
                border-style: solid;
                border-color: #e8e8e8;
                border-width: 1px;

                &:focus {
                    outline: none !important;
                    border:1px solid $camel-60;
                    box-shadow: 0 0 5px $camel-60;
                }
            }
        }

        &__error-modal {
            color: #d0021b;
        }
    }
</style>
